export default "__VITE_ASSET__CbHOc7YL__"